export const Condition = ({
  id,
  value,
  noPadding,
}: {
  id?: string
  value: string
  noPadding?: boolean
}): JSX.Element => {
  const CONDITION_COLOR: Record<string, string> = {
    MT: '#17a2b8',
    NM: 'rgba(40,167,69,0.9)',
    EX: '#82891e',
    GD: '#ffc107',
    LP: 'rgba(253,126,20,0.9)',
    PL: 'rgba(220,53,69,0.75)',
    PO: '#dc3545',
  }

  return (
    <span
      id={id}
      style={{
        color: `${CONDITION_COLOR[value]}`,
        padding: `${noPadding ? '0px' : '0px 5px'}`,
        fontWeight: 'bold',
      }}
    >
      {value}
    </span>
  )
}
